{
  "Binary": "Binario",
  "Calculation": "Cálculo",
  "Compensation-Plan": "Plan de comp.",
  "Create-Account": "Crear cuenta",
  "Dashboard": "Panel de control",
  "Document-Import": "Importación de documentos",
  "Document-Registry": "Registro de documentos",
  "Entire-Network": "Red completa",
  "Finance-Payouts": "Pagos",
  "Finance-Transactions": "Transacciones",
  "Finance-Wallet-Balances": "Saldos de billeteras",
  "Finance-Wallet-Import": "Importación de billeteras",
  "Finance": "Finanzas",
  "Genealogy": "Genealogía",
  "Import-Tree": "Importar árbol",
  "Logs": "Registros y reportes",
  "Logs-Activity-Log": "Registro de actividad",
  "Logs-Export-History": "Historial de exportación",
  "Logs-Reports": "Informes",
  "Manage-Accounts": "Gestión de cuentas",
  "Manage-Accounts-Roles": "Roles",
  "Manage-Accounts-Accounts": "Cuentas",
  "Marketing-Activity": "Actividad de marketing",
  "Network": "Red",
  "Payment-system": "Sistema de pago",
  "Profile": "Perfil",
  "Reports": "Informes",
  "Settings-Currencies": "Monedas",
  "Settings-Events": "Eventos",
  "Settings-Event-Settings": "Configuración de eventos",
  "Settings-Wallets": "Billeteras",
  "Settings-Payout-Methods": "Métodos de pago",
  "Settings-Localization": "Localización",
  "Settings-Preferences": "Preferencias",
  "Settings-Profile-Fields": "Campos de perfil",
  "Settings-Plan": "Ajustes del plan",
  "Settings": "Configuración",
  "Visual-Binary": "Binario visual",
  "Visual-Genealogy": "Genealogía visual",
  "Visual-Tree": "Árbol visual",
  "Wallet": "Billeteras",
  "Settings-Wallet-Transfer-Rules": "Configurar reglas de transferencia de billeteras",
  "periodTypes": {
    "monthly": "Mensual",
    "weekly": "Semanal",
    "daily": "Diario",
    "hourly": "Por hora",
    "quarterHourly": "Cada 15 minutos",
    "yearly": "Anual"
  }
}

